import { ReactNode } from 'react';

enum Sections {
  switching = 'switching',
  payments = 'payments',
  tariffDetails = 'tariffDetails',
}

enum Topics {
  creditCheck = 'creditCheck',
  currentSupplierContact = 'currentSupplierContact',
  currentSupplierExitFees = 'currentSupplierExitFees',
  depositQuestioning = 'depositQuestioning',
  energyPayment = 'energyPayment',
  directDebitComesOutDate = 'directDebitComesOutDate',
  monthlyCostEstimate = 'monthlyCostEstimate',
  renewableEnergy = 'renewableEnergy',
  switchPeriod = 'switchPeriod',
  whenWillTheMontlyBillBe = 'whenWillTheMontlyBillBe',
  tariffChangesAfterCancellation = 'tariffChangesAfterCancellation',
}

interface FAQTopicRaw {
  id: Topics;
  question: string;
  defaultAnswer: ReactNode;
  conditionalAnswer?: ReactNode;
  isPersonalized?: boolean;
}

export { Topics, Sections };
export type { FAQTopicRaw };
